export const builderReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "GET_BUILDERS_LIST_REQUEST":
      return { ...state, loading: true, builders: null };

    case "GET_BUILDERS_LIST_SUCCESS":
      return { ...state, loading: false, builders: action.payload };

    case "GET_BUILDERS_LIST_FAILED":
      return { ...state, loading: false, builders: null, error: action.payload };

    case "GET_BUILDER_REQUEST":
      return { ...state, loading: true, builder: null };

    case "GET_BUILDER_SUCCESS":
      return { ...state, loading: false, builder: action.payload };

    case "GET_BUILDER_FAILED":
      return { ...state, loading: false, builder: null, error: action.payload };

    case "ADD_NEW_BUILDER_REQUEST":
      return { ...state, loading: true };

    case "ADD_NEW_BUILDER_SUCCESS":
      return {
        ...state,
        loading: false,
        lastAddedBuilder: action.payload.data
      };

    case "ADD_NEW_BUILDER_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "CHANGE_BUILDER_STATUS_REQUEST":
      return { ...state, loading: true };

    case "CHANGE_BUILDER_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        builders: action.payload
      };

    case "CHANGE_BUILDER_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
